import React, { useState, useEffect } from 'react';
import "../style.css";

function OneDynamicComponent({ valueLevel, imageArray }) {
  // State to hold the currently displayed image and the next image to display
  const [currentImage, setCurrentImage] = useState(imageArray[valueLevel - 1]);
  // const [nextImage, setNextImage] = useState(imageArray[valueLevel - 1]);

  useEffect(() => {
    const newImage = imageArray[valueLevel - 1];
    const img = new Image();
    img.src = newImage;
    img.onload = () => {
      setCurrentImage(newImage);
    };
    // setNextImage(newImage);
  }, [valueLevel, imageArray]);

  return (
    <div
      className="fullscreen-image"
      style={{
        backgroundImage: `url(${currentImage})`,
      }}
    ></div>
  );
}

export default OneDynamicComponent;
